export enum filtersTypes {
  hourly = 'hourly',
  daily = 'daily',
  periodic = 'periodic',
  detailed = 'detailed',
}
